import React, { Component } from 'react'
import About from '../About'
import Heading from 'grommet/components/Heading'
import Animate from 'grommet/components/Animate'
import Pulse from 'grommet/components/icons/Pulse'
import DownIcon from 'grommet/components/icons/base/LinkDown'
import Services from '../Services'
import ServicesList from '../ServicesList'
import ServicesListPart2 from '../ServicesListPart2'
import ReadyToStart from '../ReadyToStart'
import Section from 'grommet/components/Section'
import SeparatorBar from '../SeparatorBar'
import TechnologiesCarousel from '../TechnologiesCarousel'
import Waypoint from 'react-waypoint'
import ReactCSSTransitionGroup from 'react-addons-css-transition-group'
import CopperCoastParticles from '../CopperCoastParticles'
import { withRouter } from 'react-router-dom'
import { Helmet } from 'react-helmet'
import animateScrollTo from 'animated-scroll-to'
import './Home.css'

class Home extends Component {
  pulseClickHandler = (e) => {
    e.preventDefault()
    const targetElement = document.getElementById('about')
    if (targetElement) {
      const yCoordinates = (targetElement.offsetTop)
      animateScrollTo(yCoordinates, { speed: 800 })
    }
  }
  handleEnter = () => {
    const { setParticleVisibility, setSectionProperty, history } = this.props
    setParticleVisibility('home', 'sectionOneParticlesVisible', true)
    setParticleVisibility('home', 'sectionTwoParticlesVisible', false)
    setSectionProperty('about', 'separatorBarExpanded', false)
    history.push('/')
  }
  handleRouting = (props) => {
    if (props && props.location && props.location.hash) {
      var el = props.location.hash.replace('#', '')
      setTimeout(function () {
        const targetElement = document.getElementById(el)
        if (targetElement) {
          const yCoordinates = (targetElement.offsetTop)
          animateScrollTo(yCoordinates, { speed: 800 })
        }
      }, 100)
    }
  }

  UNSAFE_componentWillReceiveProps (nextProps) {
    if (this.props.location.hash !== nextProps.location.hash) {
      this.handleRouting(nextProps)
    }
  }

  componentDidMount() {
    const { setParticleVisibility } = this.props
    setParticleVisibility('home', 'sectionOneParticlesVisible', true)
    this.handleRouting(this.props)
  }

  render() {
    const { homeParticlesVisible, windowHeight, sectionThreeSeparatorExpanded} = this.props
    const sectionHeight = windowHeight ? `${windowHeight - 72}px` : 'calc(100% - 72px)'
    const sectionThreeSeparatorClassName = sectionThreeSeparatorExpanded ? 'App-sectionThreeSeparator is-expanded' : 'App-sectionThreeSeparator'
    return (
      <div className="Home">
        <Helmet>
          <title>Copper Coast Technologies - Web Design Agency Ireland</title>
          <meta name="description" content="Based in Waterford Ireland, we are a luxury web design agency with a passionate team and international
                portfolio of successful web applications and mobile apps." />
        </Helmet>
        <Section id="agency" className="App-sectionOne" full={false} pad="none" style={{height: sectionHeight }}>
          <Waypoint scrollableAncestor={window} onEnter={this.handleEnter}/>
          <div className="App-sectionOneCopperCoast">
            <div className="App-sectionOneTextContainer">
              <Animate enter={{animation: "slide-down", "duration": 1000, "delay": 300}} keep={false}>
                <Heading className="App-sectionOneHeading" tag="h3" uppercase={true} strong={true}>we are<br/>a software consultancy<br/>focused on delivering <br/>luxury digital solutions</Heading>
              </Animate>
            </div>
            <div className="App-sectionOnePulseContainer">
              <Animate enter={{"animation": "slide-down", "duration": 1000, "delay": 1000}} keep={false}>
                <Pulse onClick={this.pulseClickHandler} className="App-sectionOnePulse" icon={<DownIcon colorIndex="grey-4" />}/>
              </Animate>
            </div>
          </div>
          <ReactCSSTransitionGroup
            transitionName="CopperCoastParticles"
            transitionEnter={true}
            transitionEnterTimeout={2000}
            transitionLeave={true}
            transitionLeaveTimeout={2000}
          >
            {homeParticlesVisible && <CopperCoastParticles mouseMoveContainerId="agency" showStars particlesId="CopperCoastParticles-sectionOne" starsId="CopperCoastStars-sectionOne" starHeight="40%"/> }
          </ReactCSSTransitionGroup>
        </Section>

        <Section id="about" className="App-sectionTwo" full={false} pad="none">
          <About {...this.props} />
        </Section>

        <Section id="creative-development" className="App-sectionThree" full={false} pad="none">
          <Services {...this.props} />
          <ServicesList />
          <TechnologiesCarousel />
          <SeparatorBar className={sectionThreeSeparatorClassName} type="horizontal"/>
          <ServicesListPart2 isMobile={this.props.isMobile}/>
        </Section>

        <Section id="ready-to-start" className="App-sectionFour" full={false} pad="none">
          <ReadyToStart {...this.props} />
        </Section>
      </div>
    )
  }
}

export default withRouter(Home)


// WEBPACK FOOTER //
// ./src/components/Home/index.js